// data/sustainabilityData.ts
export interface SustainabilitySection {
  id: string;
  title: string;
  content: string;
  bullets?: string[];
  imageUrls: string [];
  imagePosition?: 'left' | 'right';
  badges?: string[];
  icon?: string;
  isHighlighted?: boolean;
  version?: string;
}

export const sustainabilitySections: SustainabilitySection[] = [
  {
    id: 'laser-technology',
    title: 'Laser Technology',
    content: `Recent innovations in our laser printing technology have allowed us to mark denim with unprecedented precision, creating more authentic distress effects and intricate detailing than ever before.
Our advanced laser process has significantly reduced the need for hazardous chemicals such as Potassium Permanganate (KMnO₄), traditionally used in denim washing and printing.

At CrunchyFashion, laser isn't just about style, it's about combining creativity, safety, and sustainability in every piece we make.`,
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/WhatsApp%20Image%202025-11-14%20at%2019.26.09_ddaa89b2.jpg','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    badges: ['Chemical-Free', 'Precision', 'Safety', 'Innovation'],
    icon: '/icons/laser-icon.svg',
    isHighlighted: true
  },

  {
    id: 'zero-waste',
    title: 'Zero Fabric Waste',
    version: 'Zero waste Philosophy',
    content: `At CrunchyFashion, every thread counts. We are committed to ensuring that no fabric goes to waste.`,
    bullets: [
      'All leftover materials, side cuttings, and scraps are carefully gathered and repurposed into new creations.',
      'What others discard, we see as an opportunity—transforming excess into innovative denim pieces with creativity and care.',
      'This dedication allows us to minimize waste and maximize responsibility, all while maintaining the signature style our brand is known for.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/newone.png','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    badges: ['Circular', 'Efficient', 'Sustainable', 'Zero-Waste'],
    icon: '/icons/recycle-icon.svg',
    isHighlighted: true
  },
    {
    id: 'cruelty-free',
    title: 'Cruelty-Free Commitment',
    version: 'Ahimsa & Jainism',
    content: `At CrunchyFashion, our philosophy is grounded in the timeless principle of Ahimsa (non-violence), drawing inspiration from the core values of Jainism.`,
    bullets: [
      'We are fully committed to being 100% cruelty-free—never using leather, fur, or any animal-derived materials in our products.',
      'All our garments and trims are crafted with vegan-friendly alternatives that uphold both durability and distinctive style.',
      'By embracing Ahimsa in our design process, we’re able to create fashion that is bold, modern, and deeply conscious, honoring every life while redefining what it means to dress responsibly.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/Cruelty%201.png','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/Cruelty%202.png'],
    imagePosition: 'right',
    badges: ['Vegan', 'Ahimsa', 'Compassion', 'Ethical'],
    icon: '/icons/leaf-icon.svg'
  },
  {
    id: 'clean-chemistry',
    title: 'Clean Chemistry',
    content: `At CrunchyFashion, we ensure that every wash and finish is safe for both people and the planet. That’s why we exclusively use GOTS-approved, biodegradable chemicals throughout our production process.`,
    bullets: [
      'No toxic residues — Our chemicals are ZDHC-certified, leaving no toxic residues and fully meeting international safety standards.',
      'Worker safety is paramount—every step in our process is designed to protect the individuals who bring our denim to life.',
      'Planet-positive — Our planet-positive approach uses biodegradable solutions to promote cleaner water and minimize environmental impact.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/assets_task_01k6fjs6jqfze849ak8e2160df_1759312173_img_0.webp','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/got2.webp'],
    imagePosition: 'right',
    badges: ['GOTS', 'ZDHC', 'Biodegradable', 'Safe'],
    icon: '/icons/chemistry-icon.svg'
  },
  {
    id: 'water-management',
    title: 'Clean Water Management & Recycling',
    content: `At CrunchyFashion, we never waste water. Thanks to our in-house Effluent Treatment Plant (ETP), every drop used in production is carefully treated and given a second life.`,
    bullets: [
      'ETP Treatment — all wastewater undergoes thorough treatment to remove chemicals, dyes, and impurities.',
      'Recycling for Daily Use — the treated water is repurposed for toilet flushing, gardening, and facility cleaning, reducing reliance on fresh water.',
      'Environmental Protection — only clean, safe water is released from our facility, ensuring the protection of local ecosystems.',
      'Our manufacturing unit fully complies with environmental policies, meeting rigorous standards of safety and responsibility.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/sustainability_page.jpg','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    badges: ['ETP', 'Recycling', 'Conservation', 'Water-Smart'],
    icon: '/icons/water-icon.svg',
    isHighlighted: true
  },
  {
    id: 'water-saving',
    title: 'Water Saving Machines',
    content: `At CrunchyFashion, we have upgraded our production with state-of-the-art washing machines specifically designed to significantly reduce water consumption compared to traditional denim washing methods.`,
    bullets: [
      'Advanced technology ensures each garment receives its unique finish while using minimal water.',
      'By cutting water usage, we address one of the most resource-intensive stages in denim production.',
      'The outcome is authentic washes and finishes that are not only stylish but also gentler on the planet.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/water%20saving%20machines.jpeg','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    imagePosition: 'right',
    badges: ['Efficient', 'Modern', 'Resource-Saving', 'Innovation'],
    icon: '/icons/machine-icon.svg'
  },
   {
    id: 'responsible-fabrics',
    title: 'Responsible Fabrics',
    content: `At CrunchyFashion, we carefully choose fabrics that balance comfort, performance, and sustainability.`,
    bullets: [
      'Tencel™ Denim – Crafted from sustainably sourced wood pulp, Tencel™﻿ fibers provide denim with a luxuriously soft feel, excellent breathability, and a much lower environmental footprint compared to conventional fibers.',
      '100% Cotton Denim – Classic, durable, and timeless. We choose our cotton with great care to ensure exceptional quality and longevity, creating garments that age gracefully over time.',
      '98% Cotton + 2% Elastane – Designed to offer just the right amount of stretch for comfort and ease of movement, while preserving the authentic look and feel of denim.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/responsible%20fabrics.png','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/Fabric21.png'],
    badges: ['Tencel™','Sustainable', 'Quality'],
    icon: '/icons/fabric-icon.svg',
    isHighlighted: true
  },
  {
    id: 'recycled-materials',
    title: 'Recycled Threads & Interlinings',
    content: `At CrunchyFashion, sustainability is intricately woven into every layer of our garments.`,
    bullets: [
      'We incorporate recycled threads in stitching and finishing, thereby reducing the reliance on virgin fibers.',
      'Our interlinings are crafted from recycled materials, helping to divert waste from landfills and giving these materials a second life.',
      'We are committed to a future where CrunchyFashion garments will be made entirely from 100% recycled raw materials and designed to be fully recyclable after use, closing the loop in denim fashion.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/Thread.png','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/Gemini_Generated_Image_wh2qfywh2qfywh2q.png'],
    badges: ['Recycled', 'Circular', 'Innovation', 'Future-Forward'],
    icon: '/icons/thread-icon.svg',
    isHighlighted: true
  },
  {
    id: 'packaging',
    title: 'Packaging with Purpose',
    content: `At CrunchyFashion, every order is shipped using minimal, recyclable packaging. We actively avoid single-use plastics whenever possible to ensure our commitment to sustainability extends from production right through to delivery.`,
    bullets: [
      'Instead of disposable plastics, we rely on durable, reusable packaging solutions that protect our garments while minimizing environmental impact.',
      'Our packaging is thoughtfully designed to be minimal, recyclable, and eco-friendly, reflecting the same values embodied by our products.',
      'By eliminating single-use plastics, we reduce waste and help keep harmful materials out of landfills and oceans.'
    ],
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/assets_task_01k6fm0vhbfv5bkb5hy7e4ac1j_1759313498_img_1.webp','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    imagePosition: 'right',
    badges: ['Plastic-Free', 'Eco-Packaging', 'Sustainable', 'Minimal'],
    icon: '/icons/package-icon.svg'
  },
 
  {
    id: 'clean-energy',
    title: 'Clean Energy & Infrastructure',
    content: `At CrunchyFashion, sustainability is integral to every aspect of our operations. Our manufacturing facility is equipped with clean, efficient, and future-ready systems:`,
    bullets: [
      'Solar Power – Solar panels generate renewable energy for our facility, decreasing our dependence on fossil fuels.',
      'Rainwater Harvesting – Our rainwater collection systems help alleviate groundwater stress and support long-term water sustainability.',
      'PNG (Piped Natural Gas) Boilers and dryers have replaced diesel with PNG , making our heating and drying processes cleaner and more environmentally friendly.',
      'Dual-Fuel Genset – Our backup generators operate on dual fuel, optimizing efficiency while reducing emissions.'
    ],
    imageUrls:[ 'https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/clean%20energy.png','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/ahimsa.png'],
    imagePosition: 'right',
    badges: ['Solar', 'Renewable', 'Efficient', 'Green-Infrastructure'],
    icon: '/icons/energy-icon.svg'
  },
  {
    id: 'community',
    title: 'Community & Responsibility',
    content: `Beyond fashion, CrunchyFashion is deeply committed to making a positive impact. We create meaningful local employment opportunities in Noida and actively support initiatives focused on education and women’s empowerment. We believe that our responsibility extends far beyond our products, striving to contribute to lasting social change in the communities we serve.`,
    imageUrls: ['https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/WhatsApp%20Image%202025-11-14%20at%2019.26.15_947842a0.jpg','https://oextech.blr1.digitaloceanspaces.com/OexTech/CrunchyFashionclothing%40aicodepro.com/CrunchyFashion/CrunchyFashion/WhatsApp%20Image%202025-11-14%20at%2019.26.20_3d772d2f.jpg'],
    badges: ['Social Impact', 'Employment', 'Education', 'Empowerment'],
    icon: '/icons/community-icon.svg',
    isHighlighted: true
  }
];